module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-c5d109be.svg";